<template>
  <v-container :fluid="true" class="ma-0 pa-0 bg-light-blue">
    <UserPage/>
  </v-container>
</template>

<script>
import UserPage from "@/modules/personal_account/users/Base.vue"

export default {
  name: 'UserMain',
  components: { UserPage },
  data () {
    return {
    }
  },
  computed: {},
}
</script>

<style scoped lang="scss">
</style>
